export enum ResourcesTabs {
  resources = 'General Settings',
  floors = 'Floorplan Setup',
}
